/**
 * @generated SignedSource<<c992094e27c12637342e9b3907846e3b>>
 * @relayHash bfbb6c3ddb371c332b9342698d38a267
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2c6ce0a18111de36b11a6a397ec0778e80faa16dec4ad6ee75ad0922a01f8093

import type { ConcreteRequest } from 'relay-runtime';
export type useContentByLabelDataQuery$variables = {
  cql: string;
  fallbackToBody: boolean;
  first?: number | null;
  includeExcerpt: boolean;
  skipContentTitle?: boolean | null;
  skipSearchTitle?: boolean | null;
};
export type useContentByLabelDataQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly body?: {
          readonly atlas_doc_format: {
            readonly mediaToken: {
              readonly token: string | null;
            } | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly name: string | null;
          } | null> | null;
        } | null;
        readonly macroExcerpt?: {
          readonly atlasDocFormat: string | null;
        } | null;
        readonly space: {
          readonly id: string | null;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly subType: string | null;
        readonly title?: string | null;
        readonly type: string | null;
      } | null;
      readonly lastModified: string | null;
      readonly title?: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
};
export type useContentByLabelDataQuery = {
  response: useContentByLabelDataQuery$data;
  variables: useContentByLabelDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fallbackToBody"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeExcerpt"
},
v4 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skipContentTitle"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skipSearchTitle"
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "title"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = [
  {
    "alias": "search",
    "args": [
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponse",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "condition": "skipSearchTitle",
            "kind": "Condition",
            "passingValue": false,
            "selections": (v6/*: any*/)
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "lastModified"
          },
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "condition": "skipContentTitle",
                "kind": "Condition",
                "passingValue": false,
                "selections": (v6/*: any*/)
              },
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "subType"
              },
              {
                "condition": "includeExcerpt",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ConfluenceMacroExcerptBody",
                    "kind": "LinkedField",
                    "name": "macroExcerpt",
                    "plural": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "fallbackToBody",
                            "variableName": "fallbackToBody"
                          },
                          {
                            "kind": "Literal",
                            "name": "maxBlocks",
                            "value": 3
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "atlasDocFormat"
                      }
                    ]
                  },
                  {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "EmbeddedMediaToken",
                            "kind": "LinkedField",
                            "name": "mediaToken",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "token"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  (v8/*: any*/)
                ]
              },
              {
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentByLabelDataQuery",
    "selections": (v9/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentByLabelDataQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "bfbb6c3ddb371c332b9342698d38a267",
    "id": "2c6ce0a18111de36b11a6a397ec0778e80faa16dec4ad6ee75ad0922a01f8093",
    "metadata": {},
    "name": "useContentByLabelDataQuery",
    "operationKind": "query",
    "text": "query useContentByLabelDataQuery($cql:String!,$first:Int,$includeExcerpt:Boolean!,$fallbackToBody:Boolean!,$skipSearchTitle:Boolean=false,$skipContentTitle:Boolean=true){search:confluence_search(cql:$cql,first:$first){nodes{title@skip(if:$skipSearchTitle),url,lastModified,content{id,title@skip(if:$skipContentTitle),type,subType,macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:$fallbackToBody,maxBlocks:3)}\n        body@include(if:$includeExcerpt){atlas_doc_format{mediaToken{token}}},space{id,key,name},labels{nodes{id,name}}}}}}"
  }
};
})();

(node as any).hash = "7f66210a52807e1348a6380bb503b426";

export default node;
